<div
  class="cfm-backdrop"
  role="dialog"
  aria-modal="true"
  tabindex="0"
  (click)="onBackdropClick($event)"
  (keydown.escape)="cancelHandler()"
>
  <div class="cfm-modal" @fadeScale>
    <div class="cfm-header">
      <h5 class="cfm-title">Retour d'expérience Guénifey by Clésame</h5>
      <button type="button" class="cfm-close-button" aria-label="Fermer" (click)="cancelHandler()">
        <i class="fa-solid fa-circle-xmark"></i>
      </button>
    </div>

    <form [formGroup]="form" (ngSubmit)="submitHandler()" class="cfm-body">
      <div class="cfm-field">
        <label class="cfm-label" for="objet">Objet</label>
        <input
          id="objet"
          type="text"
          class="cfm-input"
          [class.cfm-input--error]="form.get('objet')?.invalid && form.get('objet')?.touched"
          formControlName="objet"
          placeholder="Sujet de votre message"
        />
        @if (form.get('objet')?.invalid && form.get('objet')?.touched) {
          <span class="cfm-error">L'objet est requis</span>
        }
      </div>

      <div class="cfm-field">
        <app-input-text [formGroup]="form" [fieldData]="messageFieldData"></app-input-text>
      </div>

      <div class="cfm-footer">
        <button type="button" class="cfm-btn cfm-btn-secondary" (click)="cancelHandler()">
          <span class="cfm-btn-content"><span class="cfm-btn-text">Annuler</span></span>
          <span class="cfm-btn-ripple"></span>
        </button>
        <button type="submit" class="cfm-btn cfm-btn-primary">
          <span class="cfm-btn-content"><span class="cfm-btn-text">Envoyer</span></span>
          <span class="cfm-btn-ripple"></span>
        </button>
      </div>
    </form>
  </div>
</div>
